module.exports = __webpack_public_path__ + "static/img/bottom5.b5b9b957.jpg";